/* Carrousel d'avis près du bouton d'achat.

   Règles de comportement :
     - une diapositive à la fois, changement automatique (3,5 s par défaut) ;
     - le défilement ne tourne que si le composant est visible à l'écran :
       inutile de faire travailler la page pour un bloc hors champ ;
     - il se met en pause au survol, quand le focus entre dedans, et quand
       l'onglet passe en arrière-plan ;
     - au doigt, un balayage horizontal fait changer d'avis ;
     - si la personne a demandé moins d'animations, aucun défilement
       automatique : les pastilles restent le seul moyen de naviguer.

   Aucune hauteur n'est calculée en JavaScript. Les diapositives sont
   superposées dans une grille (voir tiloa-brand.css) : la hauteur du bloc est
   celle de la plus haute, elle ne bouge jamais. Rien ne saute sous le bouton.
*/
(function () {
  'use strict';

  var SOBRE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function demarrer(racine) {
    var slides = [].slice.call(racine.querySelectorAll('[data-avc-slide]'));
    if (slides.length < 2) return;

    var dots = [].slice.call(racine.querySelectorAll('[data-avc-dot]'));
    var delai = parseInt(racine.getAttribute('data-interval'), 10);
    if (!delai || delai < 2000) delai = 3500;

    var index = 0;
    var minuteur = null;
    var visible = false;
    var suspendu = false;

    function afficher(i) {
      if (i === index) return;
      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      slides[index].removeAttribute('aria-hidden');
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === index);
        if (k === index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    function tourner() { afficher(index + 1); }

    function relancer() {
      arreter();
      if (SOBRE || suspendu || !visible) return;
      minuteur = window.setInterval(tourner, delai);
    }
    function arreter() {
      if (minuteur) { window.clearInterval(minuteur); minuteur = null; }
    }

    // --- pause au survol et au focus (ordinateur) ---
    racine.addEventListener('mouseenter', function () { suspendu = true; arreter(); });
    racine.addEventListener('mouseleave', function () { suspendu = false; relancer(); });
    racine.addEventListener('focusin', function () { suspendu = true; arreter(); });
    racine.addEventListener('focusout', function () {
      if (!racine.contains(document.activeElement)) { suspendu = false; relancer(); }
    });

    // --- pastilles ---
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        afficher(parseInt(d.getAttribute('data-avc-dot'), 10));
        relancer(); // on repart d'un tour complet après une action manuelle
      });
    });

    // --- balayage au doigt ---
    var x0 = null, y0 = null;
    racine.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    racine.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      // Un geste surtout vertical appartient à la page, pas au carrousel.
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        afficher(index + (dx < 0 ? 1 : -1));
        relancer();
      }
      x0 = null; y0 = null;
    }, { passive: true });

    // --- onglet en arrière-plan ---
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) arreter(); else relancer();
    });

    // --- ne tourner que si le bloc est à l'écran ---
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          visible = e.intersectionRatio >= 0.5;
          relancer();
        });
      }, { threshold: [0, 0.5] }).observe(racine);
    } else {
      visible = true;
      relancer();
    }
  }

  document.querySelectorAll('[data-tiloa-avc]').forEach(demarrer);
})();
